import React from "react";
import { Paper } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { ReportRow } from "./reportApi";

interface Props {
  rows: ReportRow[];
  total: number;
  page: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
}

const columns: GridColDef[] = [
  { field: "admissionNumber", headerName: "Admission No", width: 140 },
  { field: "scholarNumber", headerName: "Scholar No", width: 140 },
  { field: "studentName", headerName: "Student Name", width: 200 },
  { field: "fatherName", headerName: "Father Name", width: 200 },
  { field: "class", headerName: "Class", width: 120 },
  { field: "section", headerName: "Section", width: 120 },
  { field: "mobile", headerName: "Mobile", width: 140 },
  { field: "status", headerName: "Status", width: 120 },
  { field: "category", headerName: "Category", width: 140 },
  { field: "house", headerName: "House", width: 140 },
  { field: "religion", headerName: "Religion", width: 140 },
  { field: "studentType", headerName: "Student Type", width: 160 },
];

const ReportTable: React.FC<Props> = ({ rows, total, page, pageSize, onPageChange, onPageSizeChange }) => {
  return (
    <Paper sx={{ height: 520 }}>
      <DataGrid
        rows={rows.map((r, idx) => ({ id: idx, ...r }))}
        columns={columns}
        rowCount={total}
        paginationMode="server"
        pageSizeOptions={[10, 20, 50, 100]}
        paginationModel={{ page: page - 1, pageSize }}
        onPaginationModelChange={(model: { page: number; pageSize: number }) => {
          onPageChange(model.page + 1);
          onPageSizeChange(model.pageSize);
        }}
      />
    </Paper>
  );
};

export default ReportTable;
